import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const LowData = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M12 13 8.75 9.75m-3.571 9.498a9.25 9.25 0 1 1 13.642 0'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.01 6.99A8.5 8.5 0 0 0 5.732 18.74a.75.75 0 0 1-1.106 1.014c-3.6-3.924-3.499-10.024.303-13.826 3.905-3.905 10.237-3.905 14.142 0 3.802 3.802 3.903 9.902.303 13.826a.75.75 0 0 1-1.105-1.014 8.5 8.5 0 0 0-.259-11.75M8.22 9.22a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 1 1-1.06 1.06l-3.25-3.25a.75.75 0 0 1 0-1.06'
        fill='currentColor'
      />
    )}
  </IconBase>
);
